import { API_BASE, axiosApi } from "../config"
import { GeneralReturnInterface } from "../types"

export interface UserGroup {
    id: number
    name: string
    description: string
    api_key: string
    aws_profile: string
    aws_bucket_name: string
    fileprefix?: string
    billingInstitution?: string
    billingContactName?: string
    billingEmail?: string
    billingAddressLine1?: string
    billingAddressLine2?: string
    billingCity?: string
    billingState?: string
    billingCountry?: string
    billingZipcode?: string
    ts: string
    copy_emails?: string
    users_receiving_notifications?: Array<{firstName: string, lastName: string, id: number}>
    users_viewing_orders?: Array<{firstName: string, lastName: string, id: number}>
}

export interface GetUserGroupsReturnInterface {
    code: number
    groups: UserGroup[]
    message: string
}

export interface CreateUserGroupReturnInterface {
    code: number
    group?: UserGroup
    message: string
}

export const getUserGroups = async (): Promise<GetUserGroupsReturnInterface> => {
    return (await axiosApi.post(`${API_BASE}/getUserGroups`)).data
}

export const getUserGroup = async (body: { groupId: number }): Promise<{ code: number; group?: UserGroup; message: string }> => {
    return (await axiosApi.post(`${API_BASE}/getUserGroupById`, body)).data
}

export const createUserGroup = async (body: {
    name: string
    description?: string
    api_key?: string
    aws_profile?: string
    aws_bucket_name?: string
    fileprefix?: string
    billingInstitution?: string
    billingContactName?: string
    billingEmail?: string
    billingAddressLine1?: string
    billingAddressLine2?: string
    billingCity?: string
    billingState?: string
    billingCountry?: string
    billingZipcode?: string
}): Promise<CreateUserGroupReturnInterface> => {
    return (await axiosApi.post(`${API_BASE}/createUserGroup`, body)).data
}

export const updateUserGroup = async (body: {
    id: number
    name: string
    description?: string
    api_key?: string
    aws_profile?: string
    aws_bucket_name?: string
    fileprefix?: string
    billingInstitution?: string
    billingContactName?: string
    billingEmail?: string
    billingAddressLine1?: string
    billingAddressLine2?: string
    billingCity?: string
    billingState?: string
    billingCountry?: string
    billingZipcode?: string
    copy_emails?: string
}): Promise<GeneralReturnInterface> => {
    return (await axiosApi.post(`${API_BASE}/updateUserGroup`, body)).data
}

export const deleteUserGroup = async (body: {
    id: number
}): Promise<GeneralReturnInterface> => {
    return (await axiosApi.post(`${API_BASE}/deleteUserGroup`, body)).data
}

export const assignUserToGroup = async (body: {
    userId: number
    groupId?: number | null
}): Promise<GeneralReturnInterface> => {
    return (await axiosApi.post(`${API_BASE}/assignUserToGroup`, body)).data
}
